module.exports = __webpack_public_path__ + "img/wuhan-2.dfbc207b.jpg";